<div class="ttmodal">
  <div class="ttmodal__header">
    <span class="ttmodal__title">{{'Change Jobsite'| translate | async}}</span>
    <i class="material-icons ttmodal__close-button" (click)="onNoClick()" matTooltip="Close Photo">close</i>
  </div>
  <div class="ttmodal__body">
    <div>{{'Which jobsite would you like to move this equipment to?' | translate | async}}  </div>
    <mat-form-field class="input">
      <mat-select placeholder="{{'Customer' | translate | async}}"  [(ngModel)]="selectedCustomer" (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl required>
        <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
          {{customer.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field class="input">
      <mat-select   placeholder="{{'Jobsite' | translate | async}}" [(ngModel)]="selectedJobsite" ngDefaultControl required>
        <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
          {{jobsite.Name}}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
  <div class="ttmodal__footer">
    <button mat-raised-button (click)="onNoClick()">{{'Cancel'| translate | async}}</button>
    <button mat-raised-button color="warn" [class.loading]="saving" (click)="updateJobsiteClicked()"><span class="material-icons button__icon">check</span>
      <span class="button__text">{{'Update Jobsite'| translate | async}}</span></button>
  </div>
</div>
